export default __webpack_public_path__ + "static/online-doctor-consultation-mobile-application-77cd479a8b8da8bf9b400386ecb10d7b.jpg";